// @flow
import React from 'react';
import type { Node } from 'react';
import classNames from 'classnames';
import '@rover/shared/css/rover_icons/rover_icons.css';

export type Props = {
  icon: string,
  className: ?string,
};

const Icon = ({ icon, className, ...other }: Props): Node => {
  const props = {
    ...other,
    className: classNames(
      {
        'rover-icon': typeof icon === 'string' && icon.includes('rover'),
        fa: typeof icon === 'string' && icon.indexOf('fa') !== -1,
      },
      icon,
      className
    ),
  };
  return <i {...props} />;
};

Icon.defaultProps = {
  className: '',
};

export default Icon;



// WEBPACK FOOTER //
// ../react-lib/src/components/typography/Icon/Icon.jsx